import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { EnterpriseHero } from "@/components/enterprise/enterprise-hero-v2/src/enterprise-hero";

const eventsTabHeaderStyles = css({
    [media.below.xs]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`> div`]: {
            paddingBlockStart: "50px"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".enterprise-hero-header-text": {
            fontSize: "32px",
            lineHeight: "44px"
        }
    }
});

export const EventsTabContent = () => {
    const intl = useIntl();
    return (
        <div css={eventsTabHeaderStyles}>
            <EnterpriseHero
                headerText={intl.formatMessage({
                    id: "EnterpriseLandingPage.hero.events.header",
                    defaultMessage:
                        "Atlassian named number one on Fortune's Future 50 Companies list"
                })}
                bodyText={intl.formatMessage({
                    id: "EnterpriseLandingPage.hero.events.body",
                    defaultMessage:
                        "Learn how our commitment to innovation earned us the top spot among the most resilient companies."
                })}
                textAlign="left"
                cta={{
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.hero.events.cta",
                        defaultMessage: "Learn more"
                    }),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "heroSection",
                        "data-event": "clicked",
                        "data-label": "enterprise-hero-innovation-cta",
                        "data-label-english": "Learn more"
                    },
                    href: "https://www.atlassian.com/blog/inside-atlassian/fortune-future-50-list"
                }}
                ctaType="button"
                color="light"
                backgroundImgSrc={{
                    xs: "https://dam-cdn.atl.orangelogic.com/AssetLink/836u0716ramd8mrd317my8o124y4q3a1.webp",
                    sm: "https://dam-cdn.atl.orangelogic.com/AssetLink/55861a5388d07pq30h3tq7grj5yk361c.webp",
                    md: "https://dam-cdn.atl.orangelogic.com/AssetLink/55861a5388d07pq30h3tq7grj5yk361c.webp",
                    lg: "https://dam-cdn.atl.orangelogic.com/AssetLink/r502au772lc44o636l0m47mrhin7eduy.webp"
                }}
            />
        </div>
    );
};
